import { render, staticRenderFns } from "./yplhxplb.vue?vue&type=template&id=42f0bf46&scoped=true&"
import script from "./yplhxplb.vue?vue&type=script&lang=js&"
export * from "./yplhxplb.vue?vue&type=script&lang=js&"
import style0 from "./yplhxplb.vue?vue&type=style&index=0&id=42f0bf46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0bf46",
  null
  
)

export default component.exports